import ReactHtmlParser from "react-html-parser";

import { useTemplateDataContext } from "../../contexts/templateDataContext";
import { breakdownTemplate, buildTemplateString } from "../../helpers/dynamicProperties";
import { Templator } from "../../helpers/template";
import style from "../style.module.scss";
import { Props as BaseProps } from "../types";
import ClickableTemplate from "./clickableTemplate";

export default function Template(props: Props) {
	const { clickable, component, parentPropertyName, value, html, placeholder } = props;
	const { templateData } = useTemplateDataContext();
	const rootProperty = props.rootProperty || parentPropertyName;
	const template = component.component.value;
	const forceProps = { ...value, ...templateData, currentDateTime: new Date() };

	const templator = Templator(forceProps, rootProperty, template);
	const { values, properties } = templator.breakdown();

	if (clickable) {
		return (
			<ClickableTemplate
				template={template}
				values={values}
				properties={properties}
				onClick={props.scrollToField}
				html={html}
				placeholder={placeholder}
			/>
		);
	}
	const stringValue = getTemplateValue(props);

	const Tag = html ? "div" : "p";
	return <Tag className={style.displayGroup}>{html ? ReactHtmlParser(stringValue) : stringValue}</Tag>;
}

interface Props extends BaseProps {
	value?: any;
	rootProperty?: string;
	html?: boolean;
	placeholder?: string;
}

export function getTemplateValue(props: Props, customTemplate?: string) {
	const { component, parentPropertyName, value } = props;
	const { templateData } = useTemplateDataContext();
	const rootProperty = props.rootProperty || parentPropertyName;
	const template = customTemplate ?? component.component.value;
	const forceProps = { ...value, ...templateData, currentDateTime: new Date() };
	const templator = Templator(forceProps, rootProperty, template);
	const { values } = templator.breakdown();
	return templator.buildString(values);
}
